var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import require$$0, { forwardRef, useRef, useState, useEffect, useImperativeHandle } from "react";
import { Application } from "@splinetool/runtime";
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2["_" + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
      return test2[n2];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function(letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
shouldUseNative() ? Object.assign : function(target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = require$$0, g = 60103;
reactJsxRuntime_production_min.Fragment = 60107;
if (typeof Symbol === "function" && Symbol.for) {
  var h = Symbol.for;
  g = h("react.element");
  reactJsxRuntime_production_min.Fragment = h("react.fragment");
}
var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = { key: true, ref: true, __self: true, __source: true };
function q(c, a, k) {
  var b, d = {}, e = null, l = null;
  k !== void 0 && (e = "" + k);
  a.key !== void 0 && (e = "" + a.key);
  a.ref !== void 0 && (l = a.ref);
  for (b in a)
    n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
  if (c && c.defaultProps)
    for (b in a = c.defaultProps, a)
      d[b] === void 0 && (d[b] = a[b]);
  return { $$typeof: g, type: c, key: e, ref: l, props: d, _owner: m.current };
}
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx = jsxRuntime.exports.jsx;
const Spline = forwardRef(({
  scene,
  id,
  style,
  className,
  onMouseDown,
  onMouseUp,
  onMouseHover,
  onKeyDown,
  onKeyUp,
  onStart,
  onLookAt,
  onFollow,
  onLoad,
  autoRender = false
}, ref) => {
  const appRef = useRef({
    app: null
  });
  const canvasRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    setIsLoading(true);
    let speApp;
    const events = [{
      name: "mouseDown",
      cb: onMouseDown
    }, {
      name: "mouseUp",
      cb: onMouseUp
    }, {
      name: "mouseHover",
      cb: onMouseHover
    }, {
      name: "keyDown",
      cb: onKeyDown
    }, {
      name: "keyUp",
      cb: onKeyUp
    }, {
      name: "start",
      cb: onStart
    }, {
      name: "lookAt",
      cb: onLookAt
    }, {
      name: "follow",
      cb: onFollow
    }];
    if (canvasRef.current) {
      speApp = new Application(canvasRef.current, {
        autoRender
      });
      const init = async function() {
        const response = await fetch(scene);
        const buffer = await response.arrayBuffer();
        await speApp.start(buffer);
        for (let event of events) {
          if (event.cb) {
            speApp.addEventListener(event.name, event.cb);
          }
        }
        appRef.current.app = speApp;
        setIsLoading(false);
        onLoad == null ? void 0 : onLoad();
      };
      init();
    }
    return () => {
      for (let event of events) {
        if (event.cb) {
          speApp.removeEventListener(event.name, event.cb);
        }
      }
      speApp.dispose();
    };
  }, [scene]);
  useImperativeHandle(ref, () => {
    return {
      findObjectById(uuid) {
        var _a;
        return (_a = appRef.current.app) == null ? void 0 : _a.findObjectById(uuid);
      },
      findObjectByName(name) {
        var _a;
        return (_a = appRef.current.app) == null ? void 0 : _a.findObjectByName(name);
      },
      emitEvent(eventName, uuid) {
        var _a;
        (_a = appRef.current.app) == null ? void 0 : _a.emitEvent(eventName, uuid);
      },
      emitEventReverse(eventName, uuid) {
        var _a;
        (_a = appRef.current.app) == null ? void 0 : _a.emitEventReverse(eventName, uuid);
      },
      setZoom(zoomValue) {
        var _a;
        (_a = appRef.current.app) == null ? void 0 : _a._controls.zoomOut(zoomValue);
      }
    };
  }, []);
  return /* @__PURE__ */ jsx("div", {
    style: __spreadValues({
      display: `${isLoading ? "none" : "flex"}`
    }, style),
    className,
    children: /* @__PURE__ */ jsx("canvas", {
      ref: canvasRef,
      id
    })
  });
});
export { Spline };
